(() => {
  if (window.__spzdblCartProgressRefreshInit) return;
  window.__spzdblCartProgressRefreshInit = true;

  let refreshTimer;
  let activeRefresh;

  const getFreshPage = async () => {
    const url = new URL(window.location.href);
    url.searchParams.set('_spzdbl_progress_refresh', Date.now().toString());

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) return null;

    const html = await response.text();
    return new DOMParser().parseFromString(html, 'text/html');
  };

  const replaceBars = (freshDocument) => {
    if (!freshDocument) return;

    const keys = new Set(
      Array.from(document.querySelectorAll('[data-spzdbl-progress-refresh]'))
        .map((bar) => bar.getAttribute('data-spzdbl-progress-refresh'))
        .filter(Boolean)
    );

    keys.forEach((key) => {
      const selector = `[data-spzdbl-progress-refresh="${key}"]`;
      const currentBars = document.querySelectorAll(selector);
      const freshBars = freshDocument.querySelectorAll(selector);

      currentBars.forEach((bar, index) => {
        const freshBar = freshBars[index];
        if (freshBar) bar.replaceWith(freshBar);
      });
    });
  };

  const refresh = async () => {
    if (activeRefresh) return activeRefresh;

    activeRefresh = getFreshPage()
      .then(replaceBars)
      .catch(() => {})
      .finally(() => {
        activeRefresh = null;
      });

    return activeRefresh;
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 120);
  };

  document.addEventListener('cart:update', scheduleRefresh);
})();
